import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import UsersView from './users.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useUsersRoutes = () => {
  const usersComponent = (
    <ProtectedRoute module="users" checkAnySubmodule>
      <UsersView />
    </ProtectedRoute>
  );

  return (
    <Route path={pages.users.path} element={usersComponent}>
      <Route index element={usersComponent} />
      <Route path=":usersCategory" element={usersComponent} />
    </Route>
  );
};

export default useUsersRoutes;
